import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Component } from 'react';
import { Button, Checkbox, Col, Row } from 'react-bootstrap';
import Overlay from '../../../../components/ui/tooltip/Overlay';
import FlagsSharedUsersList from '../FlagsSharedUsersList';
import FlagFilterSelect from './FlagFilterSelect';
import FlagFilterDatepicker from './FlagFilterDatepicker';
import LoadingBar from '../../../../components/ui/loading/loadingBar';

export default class FlagsFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  isSharedFiltered = () => {
    return this.props.filterFlags[1].selected;
  };

  render() {
    const {
      handlerFormCollapse,
      collapseForm,
      filterFlags,
      handleFilterFlags,
      handleSelectChangePodcasts,
      podcastsList,
      valuesPodcasts,
      handleSelectChangeDocuments,
      documentsList,
      valuesDocuments,
      dateFrom,
      handleChangeFrom,
      dateTo,
      handleChangeTo,
      handleSelectChangeTags,
      tagsList,
      valuesTags,
      handleSelectOnFocus,
      onChangeHandler,
      handleSubmit,
      resetForm,
      sharedUserList,
      searchedData,
      isDocumentsFetching
    } = this.props;

    return (
      <Col xs={12} md={4} className="flags-filter__col noprint">
        <div className="flags-filter__content-container">
          <Row style={{ marginBottom: collapseForm ? '0px' : '8px' }}>
            <Col xs={12} className="flags-filter__header">
              <h4>Search Flags</h4>
              <Overlay text={collapseForm ? 'Expand' : 'Collapse'}>
                <span
                  onClick={handlerFormCollapse}
                  className="flags-filter__collapse-wraper"
                >
                  <i
                    className={`fa fa-close  ${
                      collapseForm ? 'fa-rotate-180' : ''
                    }`}
                  ></i>
                </span>
              </Overlay>
            </Col>
          </Row>
          <div
            className={`search-filters-wrapper ${
              collapseForm ? 'collapsed' : 'expanded'
            }`}
          >
            <Row style={{ marginBottom: '8px' }}>
              <Col xs={12} className="flags-filter-chip__col">
                {filterFlags.map((flag, index) => (
                  <Button
                    key={index}
                    className="flags-chip-button"
                    onClick={() => handleFilterFlags(index, flag.id)}
                  >
                    <span className="flags-chip-button__text">{flag.name}</span>
                    {flag.selected ? (
                      <CheckCircleIcon
                        fontSize="large"
                        style={{ fill: 'lightgreen' }}
                      />
                    ) : (
                      <RadioButtonUncheckedIcon
                        fontSize="large"
                        style={{ fill: '#28313b' }}
                      />
                    )}
                  </Button>
                ))}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className="flags-filter__divider"></div>
              </Col>
            </Row>
            {this.isSharedFiltered() ? (
              <Row>
                <Col xs={12}>
                  <FlagsSharedUsersList
                    sharedUserList={sharedUserList}
                    searchedData={searchedData}
                    handleUserFilterItemSelect={
                      this.props.handleUserFilterItemSelect
                    }
                    userFilterSelectedItems={this.props.userFilterSelectedItems}
                  />
                </Col>
              </Row>
            ) : (
              <></>
            )}
            <Row>
              <Col xs={12} sm={6} className="flags-filter__podcasts">
                <FlagFilterSelect
                  labelText="Podcasts"
                  onChange={handleSelectChangePodcasts}
                  options={podcastsList()}
                  placeholder=""
                  value={valuesPodcasts}
                />
              </Col>
              <Col xs={12} sm={6} className="flags-filter__documents">
                <FlagFilterSelect
                  labelText="Documents"
                  onChange={handleSelectChangeDocuments}
                  options={documentsList()}
                  placeholder=""
                  value={valuesDocuments}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className="flags-datepicker flags-datepicker__from">
                <FlagFilterDatepicker
                  labelText="From"
                  id="from"
                  selected={dateFrom}
                  onChange={handleChangeFrom}
                  placeholder="MM/DD/YYYY"
                  isClearable={true}
                />
              </Col>
              <Col xs={6} className="flags-datepicker flags-datepicker__to">
                <FlagFilterDatepicker
                  labelText="To"
                  id="to"
                  selected={dateTo}
                  onChange={handleChangeTo}
                  placeholder="MM/DD/YYYY"
                  isClearable={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} className="flags-checkbox__tags">
                <FlagFilterSelect
                  labelText="Tags"
                  onChange={handleSelectChangeTags}
                  options={tagsList()}
                  placeholder=""
                  value={valuesTags}
                  onFocus={handleSelectOnFocus}
                />
              </Col>
              {!this.state.hiddenCheckBox ? (
                <Col
                  xs={12}
                  sm={6}
                  className="checkbox-search flags-checkbox__untagged"
                >
                  Untagged flags
                  <Checkbox
                    checked={this.props.flashflag}
                    style={{ marginTop: '-4px' }}
                    onChange={onChangeHandler}
                  ></Checkbox>
                </Col>
              ) : (
                <Col
                  className="checkbox-search"
                  style={{ width: '150px', padding: 0 }}
                ></Col>
              )}
            </Row>
            <Row>
              <Col xs={12} className="grp-btn flags-filter__action-btns">
                <button
                  style={{ marginRight: '10px', width: '30%' }}
                  id="search-button"
                  type="button"
                  className="login-btn button-oval button-cta2-24"
                  onClick={handleSubmit}
                  disabled={isDocumentsFetching}
                >
                  Search
                </button>
                <button
                  style={{ marginRight: '10px', width: '30%' }}
                  type="button"
                  className="login-btn button-oval button-cta2-24"
                  onClick={resetForm}
                  disabled={isDocumentsFetching}
                >
                  Reset
                </button>
              </Col>
              {isDocumentsFetching && (
                <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                  <LoadingBar />
                </div>
              )}
            </Row>
          </div>
        </div>
      </Col>
    );
  }
}
